import { tns } from "tiny-slider";

export const initNewsTeaserSlider = () => {
  document.querySelectorAll(".news-teaser-slider--tns").forEach((slider) => {
    tns({
      container: slider,
      nav: true,
      controls: false,
      navPosition: "bottom",
      autoplayButtonOutput: false,
      autoplay: true,
      autoplayTimeout: 7500,
      speed: 700,
      autoplayHoverPause: true,
      loop: true,
      gutter: 0,
      swipeAngle: 45,
      touch: true,
      preventScrollOnTouch: "auto",
      items: 1,
      slideBy: 1,
      responsive: {
        768: { items: 4 },
      },
    });
  });
};